// truncate text at 2 lines
export const truncatedTextStyle = {
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  display: '-webkit-box',
  WebkitBoxOrient: 'vertical',
  wordBreak: 'break-word',
  WebkitLineClamp: '2',
};

export default truncatedTextStyle;
